import { useContext } from "react";
import { MediaContext } from "./mediaContextProvider";

export const useMediaMatcher = () => {
  const matchers = useContext(MediaContext);
  return matchers;
};

export const useMediaMapping = (mapping) => {
  const matchers = useMediaMatcher();
  const match = Object.keys(matchers).find((device) => matchers[device]);
  return mapping[match];
};
